import {
  ADD_GAS_STATION,
  CLEAR_GAS_STATION_FOR_DETAILS,
  CLEAR_GAS_STATION_FOR_EDIT,
  GET_ALL_GAS_STATIONS_FOR_GS_ADMIN_OR_GS_MANAGER,
  GET_ALL_GAS_STATION_ZONES,
  GET_GAS_STATION_FOR_UPDATE,
  GET_GAS_STATION_LABEL_SUGGESTION,
  UPDATE_GAS_STATION_KBA_KEY,
  UPDATE_GAS_STATION,
  UPDATE_KBA_KEY_RECORD,
} from "../actions/types";

const initialState = {
  gasStations: [],
  gasStation: {},
  gasStationForUpdate: {},
  gasStationForDetails: {},
  gasStationLabelSuggestions: [],
};

const gasStationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_GAS_STATION_ZONES:
      return {
        ...state,
        gasStations: action.payload,
      };

    case GET_ALL_GAS_STATIONS_FOR_GS_ADMIN_OR_GS_MANAGER:
      return {
        ...state,
        gasStations: action.payload,
      };

    case ADD_GAS_STATION:
      return {
        ...state,
        gasStations: state.gasStations
          .reverse()
          .concat(action.payload)
          .reverse(),
      };

    case GET_GAS_STATION_FOR_UPDATE:
      return {
        ...state,
        gasStationForUpdate: action.payload,
        gasStationForDetails: action.payload,
      };
    case GET_GAS_STATION_LABEL_SUGGESTION:
      return {
        ...state,
        gasStationLabelSuggestions: action.payload
      };

    case CLEAR_GAS_STATION_FOR_DETAILS:
      return {
        ...state,
        gasStationForDetails: {},
      };
    case CLEAR_GAS_STATION_FOR_EDIT:
      return {
        ...state,
        gasStationForUpdate: {},
      };

    case UPDATE_GAS_STATION:
      return {
        ...state,
        gasStations: state.gasStations.map((gs) =>
          gs.id !== action.payload.id ? gs : action.payload
        ),
      };
    case UPDATE_GAS_STATION_KBA_KEY:
      return {
        ...state,
        gasStations: state.gasStations.map((gs) =>
          gs.id !== action.payload.id ? gs : {...gs, kbaKey: action.payload.kbaKey}
        ),
        gasStationForDetails:
          state.gasStationForDetails?.id === action.payload.id
            ? {...state.gasStationForDetails, kbaKey: action.payload.kbaKey}
            : state.gasStationForDetails,
        gasStationForUpdate:
          state.gasStationForUpdate?.id === action.payload.id
            ? {...state.gasStationForUpdate, kbaKey: action.payload.kbaKey}
            : state.gasStationForUpdate,
      };
    case UPDATE_KBA_KEY_RECORD: {
      const incoming = action.payload.kbaKey;
      const matches = (gs) => gs?.kbaKey?.kbaKey === incoming.kbaKey;
      return {
        ...state,
        gasStations: state.gasStations.map((gs) =>
          matches(gs) ? {...gs, kbaKey: incoming} : gs
        ),
        gasStationForDetails: matches(state.gasStationForDetails)
          ? {...state.gasStationForDetails, kbaKey: incoming}
          : state.gasStationForDetails,
        gasStationForUpdate: matches(state.gasStationForUpdate)
          ? {...state.gasStationForUpdate, kbaKey: incoming}
          : state.gasStationForUpdate,
      };
    }

    default:
      return state;
  }
};

export default gasStationReducer;
